import { render, staticRenderFns } from "./EPoint.vue?vue&type=template&id=040af4f8&"
import script from "./EPoint.vue?vue&type=script&lang=js&"
export * from "./EPoint.vue?vue&type=script&lang=js&"
import style0 from "./EPoint.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QBtnToggle,QSelect,QBtn,QIcon,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QBtnToggle,QSelect,QBtn,QIcon,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd})
